export default "__VITE_ASSET___app/immutable/assets/modal-logo-light.c77xr7v3.svg__"